/**
* @author SwathiDivya Bhavaraju
* @email swathidivya.bhavaraju@ul.com
*@create date 2019-12-23 12:29:57
* @modify date 2019-12-23 12:29:57
* @desc vue component */
<template>
  <router-view :userId="userId" :roleId="roleId" :serviceId="serviceId"></router-view>
</template>
<script>
import { getServices } from '../../apis/marketPlace';

export default {
  props: ['userId', 'roleId'],
  data() {
    return {
      serviceId: '',
    };
  },
  components: {},
  methods: {
    async getServiceId() {
      const services = JSON.parse(localStorage.getItem('services'))
        ? JSON.parse(localStorage.getItem('services'))
        : await getServices();
      services.forEach((service) => {
        if (service.name === 'Smart Builder') {
          this.serviceId = service.id;
        }
      });
    },
  },
  created() {
    this.getServiceId();
  },
};
</script>
<style scoped></style>
